export default __webpack_public_path__ + "static/media/psg.9bc75435.jpg";